import React, { useState } from 'react';
import {
  TextField,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function InitScriptField({ value, onChange, edit }) {
  // Always start collapsed by default
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const getLineCount = (text) => {
    if (!text) return 0;
    return text.split('\n').filter((line) => line.trim()).length;
  };

  const getPreview = (text, maxLines = 2) => {
    if (!text) return '';
    const lines = text.split('\n').filter((line) => line.trim());
    if (lines.length <= maxLines) return text;
    return lines.slice(0, maxLines).join('\n') + '\n...';
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >
        <Typography variant='body1' fontWeight='medium'>
          Initialization Script
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!expanded && value && (
            <Typography variant='caption' color='text.secondary'>
              {getLineCount(value)} line{getLineCount(value) !== 1 ? 's' : ''}
            </Typography>
          )}
          <IconButton
            size='small'
            onClick={() => setExpanded(!expanded)}
            disabled={edit}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </Box>
      {expanded ? (
        <TextField
          fullWidth
          multiline
          rows={4}
          value={value}
          onChange={handleChange}
          disabled={edit}
          placeholder='Enter initialization script'
        />
      ) : value ? (
        <Box
          sx={{
            p: 1,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'grey.50',
            maxHeight: '60px',
            overflow: 'auto',
            cursor: 'pointer',
          }}
          onClick={() => !edit && setExpanded(true)}
        >
          <Typography
            variant='body2'
            component='pre'
            sx={{
              margin: 0,
              fontFamily: 'monospace',
              fontSize: '0.875rem',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {getPreview(value)}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            p: 1,
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'grey.50',
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => !edit && setExpanded(true)}
        >
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{ fontStyle: 'italic' }}
          >
            Click to add initialization script
          </Typography>
        </Box>
      )}
    </Box>
  );
}

